
import { Record } from "../../fable_modules/fable-library-js.5.0.0/Types.js";
import { record_type, lambda_type, unit_type, class_type, string_type } from "../../fable_modules/fable-library-js.5.0.0/Reflection.js";
import { concat } from "../../fable_modules/fable-library-js.5.0.0/String.js";

export class AnalyticsAPI extends Record {
    constructor(TrackPageView, LogWarning) {
        super();
        this.TrackPageView = TrackPageView;
        this.LogWarning = LogWarning;
    }
}

export function AnalyticsAPI_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Shared.Analytics.API.AnalyticsAPI", [], AnalyticsAPI, () => [["TrackPageView", lambda_type(string_type, lambda_type(string_type, lambda_type(class_type("System.Guid"), lambda_type(string_type, lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type]))))))], ["LogWarning", lambda_type(string_type, lambda_type(class_type("System.Guid"), lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type]))))]]);
}

export function AnalyticsAPI_RouteBuilder(_arg, m) {
    return concat("/api/analytics/", ...m);
}

